import { type Ref, ref } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import { useIsWorkingHoursUk } from '@/plugins/business/working-hours.ts'

const useSpeakToExpertModalStore = defineStore('SpeakToExpert', () => {
    const isOpen = ref(false)

    const close = () => {
        isOpen.value = false
    }
    const open = () => {
        isOpen.value = true
    }

    return {
        isOpen,
        close,
        open,
    }
})

export interface SpeakToExpertModalConfig {
    isOpen: Ref<boolean>

    close(): void

    open(): void

    runAndClose(fn: (...args: any) => any): void

    isWorkingHours: Readonly<Ref<boolean>>
}

export function useSpeakToExpertModalConfig(): SpeakToExpertModalConfig {
    const speakToExpertStore = useSpeakToExpertModalStore()
    const { isOpen } = storeToRefs(speakToExpertStore)
    const { open, close } = speakToExpertStore

    const runAndClose = (fn: (...args: any) => any) => {
        fn()
        close()
    }

    const { isWorkingHoursUk } = useIsWorkingHoursUk()

    return {
        isOpen,
        close,
        open,
        runAndClose,
        isWorkingHours: isWorkingHoursUk,
    }
}
